<template>
  <div class="tw-relative">
    <template v-if="dataDepartments.length > 1">
      <p class="tw-mb-5 tw-p-0">Sélectionner un département pour afficher les clubs.</p>
      <div class="tw-w-1/4">
        <filter-select label="Département"
                       id="department"
                       :options="departments"
                       no-results="Aucun département disponible"
                       v-model="department"
                       @change="fetchClubs()"/>
      </div>
    </template>

    <ul v-if="clubs.length" class="tw-p-0" style="list-style-image: none;">
      <li v-for="club in clubs"
          :key="club.id"
          class="tw-list-none tw-py-16 tw-border-b tw-border-dashed tw-border-blue last:tw-border-b-0">
        <h3 class="tw-p-0">{{ club.label }}</h3>
        <address class="tw-mb-5 tw-text-blue tw-text-opacity-30 tw-no-underline">{{ club.address }}</address>
        <p class="tw-mb-5 tw-p-0 tw-font-bold">
          <a class="tw-text-blue" :href="`tel:${club.phone_number}`">{{ club.phone_number }}</a><br>
          <a class="tw-text-blue" :href="`mailto:${club.email}`">{{ club.email }}</a><br>
          <a class="tw-text-blue" :href="websiteUrl(club.website)" target="_blank">{{ club.website }}</a>
        </p>
        <p class="tw-mb-5 tw-p-0">
          <strong>Correspondant</strong> :
          {{ club.representative.title }}
          {{ club.representative.first_name }}
          {{ club.representative.last_name }}
        </p>
        <p class="tw-p-0">
          <a :href="googleMapsLink(club.address)"
             target="_blank"
             class="tw-inline-block tw-px-3 tw-py-6 tw-bg-no-repeat tw-bg-left tw-bg-contain tw-font-title tw-text-sm tw-text-white"
             style="background-image: url(/wp-content/uploads/2020/12/picto-bande-simple.svg)">
            Voir sur Google Maps <span class="tw-text-2xl tw-align-middle">&#x1f852;</span>
          </a>
        </p>
      </li>
    </ul>

    <p v-else-if="department && !loading" class="tw-mt-16 tw-text-lg">
      Il n'y a pas de résultats pour votre choix, merci d'effectuer une autre sélection
    </p>

    <loader :loading="loading"/>
  </div>
</template>

<script>
import axios from 'axios';
import FilterSelect from './FilterSelect';
import Loader from './Loader';

export default {
  name: 'Clubs',
  components: {Loader, FilterSelect},
  props: {
    dataDepartments: {
      type: Array,
      default: () => [],
    },
    dataYear: {
      type: Number,
      default: () => new Date().getFullYear(),
    },
    dataDepartment: {
      type: [String, Number],
      default: '',
    },
  },
  data: ctx => ({
    loading: false,
    department: ctx.dataDepartments.length === 1 ? ctx.dataDepartments[0].code : ctx.dataDepartment,
    clubs: [],
  }),
  computed: {
    departments() {
      const departments = this.dataDepartments.map(({code, label}) => ({label: `${code} - ${label}`, value: code}));
      departments.unshift({value: '', label: 'Département', disabled: true});
      return departments;
    },
  },
  methods: {
    async fetchResource(resource, args = []) {
      this.loading = true;
      try {
        const {data} = await axios.get(window.FFFA.adminUrl, {
          params: {
            action: 'fffa_structure_api_proxy',
            resource,
            args,
          },
        });
        return data;
      } finally {
        this.loading = false;
      }
    },
    async fetchClubs() {
      if (!this.department) {
        return;
      }
      this.clubs = await this.fetchResource('clubs', [this.dataYear, this.department]);
    },
    /**
     * @param {string} website
     * @return {string}
     */
    websiteUrl(website) {
      return website.startsWith('http') ? website : `http://${website}`;
    },
    /**
     * @param {string} address
     * @return {string}
     */
    googleMapsLink(address) {
      return `https://www.google.fr/maps/?q=${address}`;
    },
  },
  mounted() {
    this.fetchClubs();
  },
};
</script>
